import { makeStyles } from "@material-ui/styles";
import palette from "../../components/styles/palette";

export const headerCellStyles = makeStyles(({ typography }) => ({
  container: {
    padding: `${typography.pxToRem(18)} ${typography.pxToRem(
      0
    )} ${typography.pxToRem(8)} ${typography.pxToRem(14)}`,
    background: palette.stopListHeader,
  },
  header: {
    color: palette.typography.black.solid,
    fontWeight: 500,
    fontSize: typography.pxToRem(12),
  },
}));

export const bodyCellStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    padding: `${typography.pxToRem(4)} ${typography.pxToRem(
      0
    )} ${typography.pxToRem(2)} ${typography.pxToRem(14)}`,
  },
  cellText: {
    color: palette.typography.black.solid,
    fontSize: typography.pxToRem(14),
  },
  cellCroppedText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  cellYellowText: {
    color: palette.yellow,
  },
  cellTextBold: {
    fontWeight: 600,
  },
  firstIcon: {
    margin: `0 ${typography.pxToRem(10)}`,
  },
  lastIcon: {
    marginLeft: typography.pxToRem(21),
  },
  link: {
    color: palette.typography.black.solid,
  },
  cellBlue: {
    backgroundColor: palette.statuses.statusBlue,
  },
  cellOrange: {
    backgroundColor: palette.modalButtons.orange,
  },
  fullHeighContainer: {
    height: "100%",
    display: "flex",
  },
  cellHighValue: {
    width: typography.pxToRem(4),
    height: "100%",
  },
}));
